import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getOfficeOnlineAppFromExtension,
    getExtensionFromFileName,
    OfficeOnlineApp,
} from 'owa-file';
import { isStringNullOrWhiteSpace } from 'owa-localize';
import { isWovenNewTabExperimentEnabled } from './isWovenNewTabExperimentEnabled';

export function getSaveToCloudLinkIfAvailable(
    fileName: string,
    isCloudy: boolean,
    isReadOnly: boolean,
    originalUrl: string
): string | null {
    // We only support this feature for classicAttachments, that are in readonly and saved to OneDrive
    // for users who have a relevant flight enabled.
    if (
        isCloudy ||
        !isReadOnly ||
        !isAnyExperiementEnabled() ||
        isStringNullOrWhiteSpace(originalUrl)
    ) {
        return null;
    }

    const extension: string = getExtensionFromFileName(fileName) || '';
    const officeApp: OfficeOnlineApp | null = getOfficeOnlineAppFromExtension(extension);
    if (officeApp === null) {
        return null;
    }

    if (isAnyWacExperimentEnabled()) {
        const referralLink = getReferralLinkFromFlight();
        const extraQueryParams = getExtraQueryParamsFromFlight();
        const querySeparator = originalUrl.indexOf('?') === -1 ? '?' : '&';
        return (
            originalUrl +
            querySeparator +
            referralLink +
            (referralLink === '' ? extraQueryParams : `&${extraQueryParams}`)
        );
    }

    return 'https://onedrive.live.com/?id=attachments';
}

function isAnyWacExperimentEnabled(): boolean {
    return (
        isFeatureEnabled('woven-saveToCloud2-viewInOneDrive') ||
        isFeatureEnabled('woven-saveToCloud2-editInOneDrive') ||
        isFeatureEnabled('woven-saveToCloud2-editInApp') ||
        isFeatureEnabled('woven-saveToCloud2-editOnline') ||
        isWovenNewTabExperimentEnabled()
    );
}

function isAnyExperiementEnabled(): boolean {
    return isAnyWacExperimentEnabled() || isFeatureEnabled('woven-saveToCloud2-openFolder');
}

function getReferralLinkFromFlight(): string {
    if (isFeatureEnabled('woven-saveToCloud2-viewInOneDrive')) {
        return 'from=OWAPromo&WT.mc_id=PROD_OL-Web_attachment_editInOneDrive_surface';
    } else if (isFeatureEnabled('woven-saveToCloud2-editInOneDrive')) {
        return 'from=OWAPromo&WT.mc_id=PROD_OL-Web_attachment_editInOneDrive_surface';
    } else if (
        isFeatureEnabled('woven-saveToCloud2-editInApp') ||
        isWovenNewTabExperimentEnabled()
    ) {
        return 'from=OWAPromo&WT.mc_id=PROD_OL-Web_attachment_editInAppName_surface';
    } else if (isFeatureEnabled('woven-saveToCloud2-editOnline')) {
        return 'from=OWAPromo&WT.mc_id=PROD_OL-Web_attachment_editOnline_surface';
    }
    return '';
}

function getExtraQueryParamsFromFlight(): string {
    if (isWovenNewTabExperimentEnabled()) {
        return 'web=1';
    }

    return '';
}
